import React from 'react'

const TabLeadDetail = ({ tabs, setTabName, tabName }) => {
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <div className='w-[45%] max-sm:w-full'>
      <div className="">
        <div>
          <nav className="-mb-px flex sm:space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                // href={tab.href}
                onClick={() => {
                  setTabName(tab.name)
                }}
                className={classNames(
                  tabName == tab.name 
                    ? 'border-[var(--brand-primary)] text-gray-900'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                  'not-italic leading-5 whitespace-nowrap max-sm:w-1/2 border-b-2 py-2 text-center px-1 text-sm font-medium cursor-pointer'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default TabLeadDetail;